import { objectKeysToUpperLowerCase } from '../utils/objects-util';
import {fixedNumber} from "../utils/math-util.js";

export function categoryProductServerModel(data) {
    const formatedExtra = extras => {
        if (extras) {
            return extras
                .filter(e => e.enabled)
                .map(e => ({
                    extra_id: e.id,
                    overrides: e.overrides && e.overrides.map(el => ({ ...el, value: String(el.value) })),
                }));
        }
    };
    return {
        Id: data.id,
        Name: data.name,
        Price: data.price,
        SKU: data.sku,
        Slug: data.slug,
        Description: data.description,
        Order: data.order,
        Featured: data.featured,
        Upselling: data.upselling,
        Enabled: data.enabled,
        Vegan: data.vegan,
        Vegetarian: data.vegetarian,
        Gluten_free: data.gluten_free,
        Spicy: data.spicy,
        Allow_comments: data.allow_comments,
        Ingredients: data.categoryIngredients
            ? objectKeysToUpperLowerCase(
                  data.categoryIngredients.map(ingredient => {
                      return (
                          data.ingredients.find(f => f.name === ingredient) || {
                              name: ingredient,
                              image: null,
                              image_settings: null,
                          }
                      );
                  })
              )
            : objectKeysToUpperLowerCase(data.ingredients, true),
        Image_settings: data.image_settings,
        Enable_schedule: data.enable_schedule,
        Preorder_schedule: data.preorder_schedule,
        Schedule: data.schedule,
        Max: data.max,
        Price_before_discount: data.price_before_discount,
        Extras: data.extras ? formatedExtra(data.extras) : formatedExtra(data.categoryExtras),
        Tag: data.tag,
        Unit_weight: data.unit_weight || 0,
        Weighed: data.weighed || false,
        Weight_range: fixedNumber(data.weight_range / 100, 2) || 0,
        Production_line: data.production_line || "",
        Hide_from_main_app_menu: data.hide_from_main_app_menu || false,
        Applicable_channels: data.applicable_channels || [],
    };
}
